/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_Check_In_SuccessInputs */

const en_roster_check_in_success = /** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest checked in!`)
};

const es_roster_check_in_success = /** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Invitado registrado!`)
};

const fr_roster_check_in_success = /** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invité enregistré !`)
};

const de_roster_check_in_success = /** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gast eingecheckt!`)
};

const id_roster_check_in_success = /** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu sudah check-in!`)
};

/** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */
const ja_roster_check_in_success = en_roster_check_in_success;

/** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */
const zh_roster_check_in_success = en_roster_check_in_success;

/** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */
const ar_roster_check_in_success = en_roster_check_in_success;

/** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */
const it_roster_check_in_success = en_roster_check_in_success;

/** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */
const ru_roster_check_in_success = en_roster_check_in_success;

/** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */
const pt_roster_check_in_success = en_roster_check_in_success;

/** @type {(inputs: Roster_Check_In_SuccessInputs) => LocalizedString} */
const ko_roster_check_in_success = en_roster_check_in_success;

/**
* | output |
* | --- |
* | "Guest checked in!" |
*
* @param {Roster_Check_In_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_check_in_success = /** @type {((inputs?: Roster_Check_In_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_Check_In_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_check_in_success(inputs)
	if (locale === "es") return es_roster_check_in_success(inputs)
	if (locale === "fr") return fr_roster_check_in_success(inputs)
	if (locale === "de") return de_roster_check_in_success(inputs)
	if (locale === "ja") return ja_roster_check_in_success(inputs)
	if (locale === "zh") return zh_roster_check_in_success(inputs)
	if (locale === "ar") return ar_roster_check_in_success(inputs)
	if (locale === "id") return id_roster_check_in_success(inputs)
	if (locale === "it") return it_roster_check_in_success(inputs)
	if (locale === "ru") return ru_roster_check_in_success(inputs)
	if (locale === "pt") return pt_roster_check_in_success(inputs)
	return ko_roster_check_in_success(inputs)
});